module.exports = __webpack_public_path__ + "media/empty-states/schedules-5969f796.png";